export const APP_ERROR_TITLE = "Something went wrong";
export const APP_ERROR_DESCRIPTION =
  "An unexpected error occurred. Please try again, or return to the home page.";
export const APP_ERROR_RETRY_LABEL = "Try again";
export const APP_ERROR_HOME_LABEL = "Go home";
